import type { AuthMeResponse } from '@/api/auth.api';
import type { Capability } from '@/api/capabilities.api';

/**
 * Client-side capability check — mirrors the server's
 * `requireCapability` rule exactly (ADR-017):
 *   - visionary + integrator hold EVERY capability implicitly
 *   - other roles hold only what /api/auth/me lists as granted
 *
 * This gates UI VISIBILITY only. The server re-enforces on every
 * request; a stale or spoofed client check can't grant real access.
 */

const SUPERADMIN_ROLES = new Set(['visionary', 'integrator']);

export function hasCapability(me: AuthMeResponse, capability: Capability): boolean {
  if (SUPERADMIN_ROLES.has(me.membership.role)) return true;
  return (me.capabilities ?? []).includes(capability);
}

export function isSuperadmin(me: AuthMeResponse): boolean {
  return SUPERADMIN_ROLES.has(me.membership.role);
}
